/* global define:true */


/* grab the logger so we can warn about being in the fallback mode */

var _logger = require('xo-beaver/dist/logger');

/** Name:  Tray height helper */
define(['squid/index', 'jquery'], function (squid, $) {
    squid.module('xo-tray-height.directive', ['squid']).directive('xoTrayHeight', function ($timeout) {
        return {
            restrict: 'A',
            link: function link($scope, element, attrs) {
                // Check to see if we can use the safer full height approach
                // or if we need to fallback to calculating the height using
                // math and relying on the "right" timing.
                var topClass = 'xo-sidebar-wrapper';
                var topSelector = '.' + topClass;
                var topElem = document.querySelector(topSelector);
                var inScope = topElem && topElem.querySelector('[xo-tray-height]');
                var useNewFlow = topElem && inScope;

                /**
                 * NOTE:
                 * The following code, despite being the "new" flow, is still
                 * a stopgap solution until such time as the markup and or
                 * CSS undergo an overhaul. It relies on the more stable
                 * cascading relative/absolute positioning and 100% height
                 * *and* the fact that the code is an instance of xo-tray-height
                 * within the xo-sidebar-wrapper.
                 */
                function calculate() {
                    var curElem = element[0];

                    while (!~curElem.className.indexOf(topClass)) {
                        var style = getComputedStyle(curElem, null);

                        if (style.position !== 'absolute') {
                            curElem.style.position = 'relative';
                        }
                        curElem.style.height = '100%';
                        curElem = curElem.parentNode;
                    }
                }

                /**
                 * NOTE:
                 * The following DEPRECATED version of the calculate method
                 * relies on calculating the heights using math. This heavy
                 * handed approach is fine if it is called at the right times
                 * and often enough; however, this criteria is hard to achieve.
                 *
                 * A markup and styles overhaul is recommended to do away with
                 * both of these methods.
                 */
                function deprecatedCalculate() {
                    // DEPRECATED
                    _logger.$logger.warn('xo-tray-height-fallback', {
                        message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
                    });
                    var height;
                    var headerHeight;
                    var mainHeight;
                    var trayMinheight = 400;
                    var asideContentHeight;
                    var $aside = $(element).parents('aside:visible');
                    var $asideContent = $aside.find('.asideContent');

                    if (!$aside || !$asideContent) {
                        return;
                    }

                    // Updates the tray height to the section height
                    headerHeight = $aside.find('.header').outerHeight(true);
                    mainHeight = $('#main').outerHeight(true);

                    height = mainHeight - headerHeight;
                    asideContentHeight = $asideContent.outerHeight(true);
                    if ($scope.miniBrowser) {
                        $aside.find('.aside').css('height', '534px');
                        var minHeight = 534 - headerHeight;

                        $asideContent.css('height', minHeight);
                    } else if (asideContentHeight > height) {
                        $asideContent.css('height', height);
                        $aside.find('aside:visible').addClass('hasScroll');
                    } else {
                        height = height > trayMinheight ? height : trayMinheight;
                        $asideContent.css('height', height);
                        $aside.removeClass('hasScroll');
                    }
                }

                if (useNewFlow) {
                    calculate();
                } else {
                    $timeout(deprecatedCalculate, 1);

                    $scope.$on('SidebarError', function () {
                        deprecatedCalculate();
                    });
                }
            }
        };
    });
});

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-tray-height/dist/directive.js
// module id = ./components/xo-tray-height/dist/directive.js
// module chunks = 1